import Cookies from 'js-cookie';
import React from 'react'
import { Navigate } from 'react-router-dom'
function HandleLogin({children}) {

    const token = Cookies.get('token'); 

    if(token){
        return <Navigate to="/" />;
    }

  return children
}

export default HandleLogin
